import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object, string, number } from "yup";

export interface ClinicBlockData {
  data: string;
  reason: number;
  message: string | null;
}

export type FetchClinicBlockResponse = ClinicBlockData;

export const fetchClinicBlock = async (): Promise<FetchClinicBlockResponse> => {
  const response = await fetchData("/dietitian/clinic/block", APIMethods.GET);

  return await schema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/clinic/block"));
};

const schema = object({
  data: string().required(),
  reason: number().oneOf([1, 2]).required(),
  message: string().nullable().default(null),
});
